import React, { FC, memo, useMemo } from 'react';

import { useRelayEnvironment } from 'react-relay';

import { getBasenameFromSetting, getServerEnvironment } from 'shared-lib';
import { useRoutingContext } from 'app-core';

import AppRoutes from './AppRoutes';

export const AppLayout: FC = () => {
  const basename = useMemo(() => {
    return getBasenameFromSetting(getServerEnvironment());
  }, []);

  const environment = useRelayEnvironment();
  const routingContext = useRoutingContext();

  return (
    <AppRoutes
      routingContext={routingContext}
      environment={environment}
      basename={basename}
    />
  );
};

export default memo(AppLayout);
